import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FilteredTagsResolverService } from "./services/tags-resolver.service";

@NgModule({
  imports: [CommonModule],
  providers: [FilteredTagsResolverService]
})
export class TagsDataAccessModule {}
